import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputMask, InputMaskChangeParams } from 'primereact/inputmask';

import { ModelOfBidding, ModelOfNegocio } from 'src/database';

import useIntersectionObserver from 'src/components/IntersectionObserver/useIntersectionObserver';
import LoadingScreen from '../../components/LoadingScreen';
import { useListNegociosController, } from '../../controllers/Negocio/ListNegociosController';
import { Toast } from 'primereact/toast'; 
import classNames from 'classnames';
import { PulseLoader } from 'react-spinners';
import { Divider } from 'primereact/divider';
import { InputNumber } from 'primereact/inputnumber';
import { AutoComplete } from 'primereact/autocomplete';
import { dateToString } from 'src/utils/dateToString';
import { Tooltip } from 'primereact/tooltip';

interface InputMaskProps {
    label: string;
    mask: string;
    placeholder: string;
}

interface filteredProps {
    label: string;
    value?: string;
}

const NegociosList: React.FC = () => {
    const { getNegocioListController, handleNegocioListController } = useListNegociosController();
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [inputMask, setInputMask] = useState<InputMaskProps>({ label: 'CPF', mask: '999.999.999-99', placeholder: '___.___.___-__' });
    const [valueFuel, setValueFuel] = useState('');
    const [filteredFuels, setFilteredFuels] = useState<filteredProps[]>([{ label: '', value: '' }]);

    if (getNegocioListController.loading) {
        return <LoadingScreen />
    };

    const maskOptions = [
        { label: 'CPF', mask: '999.999.999-99', placeholder: '___.___.___-__' },
        { label: 'CNPJ', mask: '99.999.999/9999-99', placeholder: '__.___.___/____-__' },
    ];

    const tableHeader = (
        <div className="table-header p-grid p-d-flex p-jc-between">
            <h5 className="p-m-0">Negocios</h5>
            <span className="p-input-icon-left p-search-bar">
                <i className="pi pi-search" />
                <InputText type="search" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const actionBodyTemplate = (Negocio: ModelOfNegocio) => {
        return (
            
            <React.Fragment>
                <Tooltip target=".unity-editarnegocio-btn" content="Editar negocio" position="top" />
                <Tooltip target=".unity-excluirnegocio-btn" content="Excluir negocio" position="top" />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2 unity-editarnegocio-btn" onClick={() => handleNegocioListController.openEditDialog(Negocio)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger unity-excluirnegocio-btn" onClick={() => handleNegocioListController.openDeleteDialog(Negocio)} />
            </React.Fragment>
        );
    };

    const editNegocioDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleNegocioListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getNegocioListController.formik.handleSubmit() }} />
        </React.Fragment>
    );



    const deleteNegocioDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleNegocioListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getNegocioListController.selectedNegocio && handleNegocioListController.removeNegocio(getNegocioListController.selectedNegocio)
                }}
            />
        </React.Fragment>
    );

    const leftNegocioToolbar = () => {
        return (
            <Link to="/negocioForm">
                <Button label="Cadastrar negocio" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    const HEADER_NOME = (rowData: ModelOfNegocio) => {
        return (
            <React.Fragment>
                <span className="left-header">RAZÃO SOCIAL</span>
                {rowData.RAZAOSOCIAL}
            </React.Fragment>
        );
    }

    const HEADER_CNPJ = (rowData: ModelOfNegocio) => {
        return (
            <React.Fragment>
                <span className="left-header">CNPJ</span>
                {rowData.CNPJ}
            </React.Fragment>
        );
    }

    const Loader: React.FC = ({ children }) => {
        const divRef: any = useRef<HTMLDivElement | null>(null);

        const [isVisible] = useIntersectionObserver({
            elementRef: divRef,
        });

      

        return (
            <div
                ref={divRef}
                style={{
                    minHeight: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {children}
            </div>
        )
    }

    const handleChangeCPFCNPJ = (e: InputMaskChangeParams) => {
        console.log("InputMaskChangeParams: ", e)
        console.log("InputMaskChangeParams: ", e.target)
        console.log("InputMaskChangeParams: ", e.target.value)
        console.log("InputMaskChangeParams: ", e.value)
        getNegocioListController.formik.setFieldValue('CPF_CNPJ', e.target.value);
    };


    return (
        <div>
            <Toast ref={getNegocioListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftNegocioToolbar}></Toolbar>

                <DataTable
                    header={tableHeader}
                    globalFilter={globalFilter} rowHover
                    className="responsive-table p-datatable-sm"
                    dataKey="ID" autoLayout scrollable scrollHeight={'100%'}
                    value={getNegocioListController.NegociosData}
                >
                    <Column field="NOME" header="NOME" body={HEADER_NOME}></Column>
                    <Column field="CPF_CNPJ" header="CNPJ" body={HEADER_CNPJ}></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
               
            </div>


            <Dialog
                className="p-fluid"
                style={{ width: '90%' }}
                visible={getNegocioListController.editDialog}
                onHide={handleNegocioListController.closeEditDialog}
                onShow={() => {
                    getNegocioListController.formik.setValues(getNegocioListController.selectedNegocio);
                    if (getNegocioListController.selectedNegocio.CNPJ
                        && getNegocioListController.selectedNegocio.CNPJ.length <= 14) {
                        setInputMask(maskOptions[0]);
                    } else {
                        setInputMask(maskOptions[1]);
                    }
                }}
                footer={editNegocioDialogFooter}
                header={`Editar negocio ${getNegocioListController.selectedNegocio?.RAZAOSOCIAL}`}
                modal
            >
                {getNegocioListController.loadingEdit ? <LoadingScreen color="#0388e5" /> : <></>}
                <div className="p-grid p-fluid">
                    <div className="p-field p-col-12 p-md-4">
                        <label htmlFor="cpf" >CPF / CNPJ</label>
                        <InputMask id="cpf" disabled
                            mask='99.999.999/9999-99'
                            {...getNegocioListController.formik.getFieldProps('CPF_CNPJ')}
                            onChange={handleChangeCPFCNPJ}>

                            {(inputProps: any) => (
                                <input
                                    {...inputProps}
                                    id="cpf"
                                    name="CPF_CNPJ"
                                    disabled={false}
                                />
                            )}

                        </InputMask>

                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getNegocioListController.formik.touched.CNPJ && getNegocioListController.formik.errors.CNPJ,
                            'popup-form-inactive': !(getNegocioListController.formik.touched.CNPJ && getNegocioListController.formik.errors.CNPJ),
                        })}
                        >{getNegocioListController.formik.errors.CNPJ}</div>
                    </div>

                    <div className="p-field p-col-12 p-md-8">
                        <label htmlFor="nomeComp" >Nome completo</label>
                        <InputText id="nomeComp"
                            {...getNegocioListController.formik.getFieldProps('NOME')}
                            onChange={getNegocioListController.formik.handleChange('NOME')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getNegocioListController.formik.touched.RAZAOSOCIAL && getNegocioListController.formik.errors.RAZAOSOCIAL,
                            'popup-form-inactive': !(getNegocioListController.formik.touched.RAZAOSOCIAL && getNegocioListController.formik.errors.RAZAOSOCIAL),
                        })}
                        >{getNegocioListController.formik.errors.RAZAOSOCIAL}</div>
                    </div>

                    

                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getNegocioListController.deleteDialog}
                onHide={handleNegocioListController.closeDeleteDialog}
                footer={deleteNegocioDialogFooter}
                header="Remover negocio"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getNegocioListController.selectedNegocio && <span>Você tem certeza que deseja remover <b>{getNegocioListController.selectedNegocio.RAZAOSOCIAL}</b>?</span>}
                </div>
            </Dialog>        
        </div>

    );
};

export default NegociosList;